import React, { useState, useEffect } from 'react'

/**
 * OverlayIntro Component
 * Simple intro overlay triggered by doorbell press
 */
export function OverlayIntro({ isActive, onRequestClose, onEnter }) {
  const [animationState, setAnimationState] = useState('closed') // 'closed' | 'opening' | 'open' | 'closing'

  // Handle state changes from parent
  // Proper 4-state machine: closed → opening → open → closing → closed
  useEffect(() => {
    if (isActive && animationState === 'closed') {
      // Start opening animation (only from closed state)
      setAnimationState('opening')
      
      // After animation completes, set to open
      const timer = setTimeout(() => {
        setAnimationState('open')
      }, 500)
      
      return () => clearTimeout(timer)
    } else if (!isActive && (animationState === 'open' || animationState === 'opening')) {
      // Start closing animation (from open OR opening state)
      // Allow closing from 'opening' to handle rapid close requests
      setAnimationState('closing')
      
      // After animation completes, set to closed
      const timer = setTimeout(() => {
        setAnimationState('closed')
      }, 500)
      
      return () => clearTimeout(timer)
    }
  }, [isActive]) // REMOVED animationState from dependencies to prevent cleanup canceling timers

  // Enter and ESC key handling - add listener as soon as overlay becomes active
  useEffect(() => {
    // Only add listener when overlay is active (opening or open states)
    if (!isActive) return
    
    const handleKeyDown = (event) => {
      if (event.key === 'Enter' || event.code === 'Enter') {
        event.preventDefault()
        event.stopPropagation()
        onEnter() // Trigger the same function as the Enter button
      } else if (event.key === 'Escape') {
        event.preventDefault()
        event.stopPropagation()
        onRequestClose() // Trigger the same function as the Close button
      }
    }

    window.addEventListener('keydown', handleKeyDown, true) // Use capture phase
    return () => {
      window.removeEventListener('keydown', handleKeyDown, true)
    }
  }, [isActive, onEnter, onRequestClose])

  // Don't render if closed
  if (animationState === 'closed') return null

  // Determine CSS class based on animation state
  const getClassName = () => {
    if (animationState === 'opening') return 'overlay-container opening'
    if (animationState === 'closing') return 'overlay-container closing'
    return 'overlay-container open'
  }

  return (
    <div className={getClassName()}>
      <div className="overlay-panel intro">
        <div className="overlay-scroll-area">
          <div className="overlay-content">
            <div className="text-box-base">
            <p className="text-body-large">
              I'm Björn, a creative soul with a passion for social design, sustainable technology, and inclusive storytelling. Welcome to my world of creations. I'm currently out and about gathering some inspiration and skills for my next design endeavor, but please! feel at home, have a look around and don't hesitate to reach out if you'd prefer the longer story behind one of my many journeys across the lands of product development
            </p>
            </div>
          </div>
        </div>
        <div className="btn-set-1">
              <button className="btn-xlarge secondary" onClick={onRequestClose}>
              Close
            </button>
            <button className="btn-xlarge" onClick={onEnter}>
              Enter
              <span className="material-symbols-rounded">subdirectory_arrow_left</span>
            </button>
        </div>
      </div>
    </div>

  )
}

